export default {
  text: 'IDRA është anëtare e ESOMAR dhe e çertifikuar me ISO 20252-2012, standardin ndërkombëtar mbi hulumtimin social, të opinionit dhe tregjeve dhe ISO 9001-2008 për Kontrollin e Cilësisë dhe Sigurisë',
  contact: 'kontakt',
  termsAndConditions: 'Termat dhe kushtet e përdorimit',
  unSubcribe: 'UnSubcribe',
  coppyRight: ' © Copyright IDRA. Te gjitha të drejtat e rezervuara',
};
